import { useState } from 'react';
import { toast } from 'sonner';
import { CalendarRange, PenLine } from 'lucide-react';
import TimesheetSign from './TimesheetSign';
import { exportTimesheet, monthOf } from '../lib/timesheet';

// month + year as selects so the names follow the app language (native month input uses the browser locale)
function MonthPick({ t, value, set }) {
  const [y, m] = value.split('-').map(Number), now = new Date().getFullYear();
  const go = (yy, mm) => set(`${yy}-${String(mm).padStart(2, '0')}`);
  return (
    <span className="ts-month" data-testid="timesheet-month">
      <select aria-label={t.tzMonth} data-testid="timesheet-month-sel" value={m} onChange={(e) => go(y, +e.target.value)}>
        {Array.from({ length: 12 }, (_, i) => <option key={i} value={i + 1}>{new Date(2000, i, 1).toLocaleString(undefined, { month: 'long' })}</option>)}
      </select>
      <select aria-label={t.tzYear} data-testid="timesheet-year-sel" value={y} onChange={(e) => go(+e.target.value, m)}>
        {Array.from({ length: 6 }, (_, i) => now - 4 + i).map((v) => <option key={v} value={v}>{v}</option>)}
      </select>
    </span>
  );
}

// monthly timesheet per staff member (all projects or current project) as Excel
export default function TimesheetBox({ t, lang, projects, project }) {
  const [month, setMonth] = useState(() => monthOf(Date.now()));
  const [scope, setScope] = useState('all');
  const [sign, setSign] = useState(false);
  const go = () => {
    const n = exportTimesheet(scope === 'all' ? projects : [project], month, lang, scope === 'all' ? t.tzTitle : `${t.tzTitle}_${(project.title || '').replace(/[^\w-]+/g, '_')}`);
    n ? toast.success(t.tzOk.replace('{n}', n)) : toast.message(t.tzNone);
  };
  return (
    <div className="ts-box" data-testid="timesheet-box">
      <b><CalendarRange size={16} /> {t.tzTitle}</b>
      <div className="ts-row">
        <MonthPick t={t} value={month} set={setMonth} />
        <div className="ts-seg">
          {['all', 'cur'].map((k) => <button key={k} type="button" className={`chip seg ${scope === k ? 'on' : ''}`} data-testid={`timesheet-scope-${k}`} onClick={() => setScope(k)}>{k === 'all' ? t.tzAll : t.tzCur}</button>)}
        </div>
        <button className="btn btn-green" data-testid="timesheet-export-btn" disabled={!month} onClick={go}>{t.tzBtn}</button>
        <button className="btn btn-dark" data-testid="timesheet-sign-btn" disabled={!month} onClick={() => setSign(true)}><PenLine size={16} /> {t.tzSignBtn}</button>
      </div>
      {sign && <TimesheetSign t={t} month={month} projects={scope === 'all' ? projects : [project]} onClose={() => setSign(false)} />}
    </div>
  );
}
